/**
Author - Brijesh Pandey
Git - https://github.com/Brijesh-Pandey
**/

import SkipFlow from "./SkipFlow.container";

export default SkipFlow;
